import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import { IconButton } from 'components/buttons';
import { useTranslation } from 'hooks';
import { Card, EmptySection, EmptyText } from './style';

function Section({
  addPath,
  addPathState,
  children,
  className,
  editPath,
  editPathState,
  title,
  showExpandCollapse,
  isExpanded,
  handleCollapseExpand,
  size = '12',
  ...rest
}) {
  const { t, tr } = useTranslation();

  const headerAction = useMemo(
    () => (
      <React.Fragment>
        {addPath && (
          <IconButton
            component={Link}
            icon="Plus"
            to={addPath}
            state={addPathState} // ✅ support background modal
          />
        )}
        {editPath && (
          <IconButton
            component={Link}
            icon="Edit"
            to={editPath}
            state={editPathState} // ✅ support background modal
          />
        )}
      </React.Fragment>
    ),
    [addPath, addPathState, editPath, editPathState, isExpanded]
  );

  return (
    <Card className={className} headerContent={headerAction} title={tr(title)} {...rest} style={{ width: '100%' }} >
      {children || (
        <EmptySection>
          <EmptyText>{t('message.sectionIsEmpty')}</EmptyText>
          <EmptyText>{t('message.addMoreInformation')}</EmptyText>
        </EmptySection>
      )}
    </Card>
  );
}

Section.propTypes = {
  addPath: PropTypes.string,
  addPathState: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  className: PropTypes.string,
  editPath: PropTypes.string,
  editPathState: PropTypes.object,
  title: PropTypes.string,
  size: PropTypes.string
};

export default Section;
